import { useContext, useMemo } from 'react'
import { context } from '../../context'

export const useSelectServices = () => {
  const { state } = useContext(context)

  const services = useMemo(() => state.services, [state.services])

  return services
}
